import React from 'react';
import { reportHydrationEnd } from '@atlassian/jira-ssr-controller/src/use-is-page-hydrating.tsx';
import { RenderAfterHydrationCompletion } from './RenderAfterHydrationCompletion.tsx';

const Setter = () => {
	reportHydrationEnd();
	return null;
};
/**
 * Sets global state indicating hydration has finished. Can also be safely used without hydration being used.
 */
export const HydrationFinishedSetter = (): React.JSX.Element => (
	<RenderAfterHydrationCompletion>
		<Setter />
	</RenderAfterHydrationCompletion>
);
